import { render, staticRenderFns } from "./user-replies.vue?vue&type=template&id=035c34aa&scoped=true&"
import script from "./user-replies.vue?vue&type=script&lang=js&"
export * from "./user-replies.vue?vue&type=script&lang=js&"
import style0 from "./user-replies.vue?vue&type=style&index=0&id=035c34aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c34aa",
  null
  
)

export default component.exports